module.exports = __webpack_public_path__ + "static/media/logo_blue_black.74ea2a9f.svg";